"use client"
import { Facepile as DSFacepile, FacepileProps } from "@opensea/ui-kit"
import React, { ElementRef, forwardRef } from "react"
import { AvatarImage } from "../Avatar"

export const Facepile = forwardRef<
  ElementRef<typeof DSFacepile>,
  FacepileProps
>(function Facepile(props, ref) {
  return (
    <DSFacepile
      {...props}
      overrides={{
        Avatar: { renderImage: AvatarImage, ...props.overrides?.Avatar },
        ...props.overrides,
      }}
      ref={ref}
    />
  )
})
